import { useTranslation } from "react-i18next";
import icon_delete from "../../../layout/others/icon_delete.svg";

export default function SalaryCondition({
  model,
  mainLabel,
  contractTypes,
  monetaryList,
  errors,
  setModel,
  index,
  deleteSalaryLocation
}) {
  let { t } = useTranslation();
  
  function onChangeSalary(event) {
    let value = event.target.value;
    if(value === ""){
      value = null;
    }
    setModel({ ...model, salaryExpected: value });
  }
  
  function onChangeExpectedSalaryType(event) {
    setModel({
      ...model,
      salaryExpectedValueIsLiquid:
        event.target.id === "salaryExpectedValueIsLiquidId"
    });
  }
  
  function onChangeAvailabilityAndConditions(event) {
    let value = event.target.value;
    if(value === "0"){
      value = null;
    }
    setModel({ ...model, [event.target.name]: value });
  }

  return (
    <div className="salary-condition">
      <div className="salary-info">
        <div className="form-group salary-width">
          <label>{t(mainLabel)}</label>
          <input
            type="number"
            placeholder="0,00€"
            id="salaryExpectedPerLocation"
            name="salaryExpectedPerLocation"
            onChange={onChangeSalary}
            min={0}
            onInput={(e) => {
              e.target.value = e.target.value.slice(0, 10);
            }}
            value={model.salaryExpected || ""}
          />
        </div>

        <div className="form-group type-contract-style">
          <label>{t("Currency")}</label>
          <select
            id="expectedSalaryCurrencyId"
            className="form-select"
            name="expectedSalaryCurrencyId"
            onChange={onChangeAvailabilityAndConditions}
            value={model.expectedSalaryCurrencyId || ""}
            required
          >
            <option value={0} selected>
              {t("currency...")}
            </option>
            {monetaryList?.map((item) => (
              <option key={item.id} value={item.id}>
                {t(item.description)}
              </option>
            ))}
          </select>
        </div>

        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name={`salaryExpectedValueIsLiquid${index}`}
            id="salaryExpectedValueIsLiquidId"
            onChange={onChangeExpectedSalaryType}
            checked={model.salaryExpectedValueIsLiquid}
          />
          <label htmlFor="SalaryExpectedValueIsLiquid">{t("Liquid")}</label>
          <input
            className="form-check-input"
            type="radio"
            name={`salaryExpectedValueIsLiquid${index}`}
            id="salaryExpectedValueIsNotLiquidId"
            onChange={onChangeExpectedSalaryType}
            checked={!model.salaryExpectedValueIsLiquid}
          />
          <label htmlFor="SalaryExpectedValueIsNotLiquid">{t("Gross")}</label>
        </div>
        <div className="form-group type-contract-style">
          <label htmlFor="desiredContractType">
            {t("Desired Contract Type")}
          </label>
          <select
            id="expectedContract"
            name="expectedContract"
            className="form-select"
            onChange={onChangeAvailabilityAndConditions}
            value={model.expectedContract || ""}
            required
            title={t("Selecione um item da lista.")}
          >
            <option value={0} selected>
              {t("Select...")}
            </option>
            {contractTypes?.map((item) => (
              <option key={item.id} value={item.id}>
                {t(item.description)}
              </option>
            ))}
          </select>
        </div>
        {index > 0 && (
            <div className="col">
              <button
                type="button"
                className="app-button btn-second btn-md"
                onClick={() => deleteSalaryLocation(index)}
                style={{marginLeft:"25px", marginTop:"25px"}}
              >
                <img src={icon_delete} alt="delete" width="12px" height="auto" />{" "}
                {t("Delete")}
              </button>
            </div>
          )}
      </div>
    </div>
  );
}
